/* The (old) AddressFormContainer with separate entry for each field */
import { FormContextConsumer } from '#/components/Form/FormContext';

import { AddressFormSeparateContainerInternal } from './AddressFormSeparateContainerInternal';

// TODO: Fix this the next time the file is edited.
// oxlint-disable-next-line typescript/no-explicit-any
export function AddressFormSeparateContainer(props: Record<string, any>) {
  const addressKey =
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.index !== undefined ? `addresses.${props.index}` : 'address';
  return (
    <FormContextConsumer>
      {({
        clearErrors,
        updateValueWith,
        setFetchingAddress,
        errors,
        getValue,
      }) => (
        <AddressFormSeparateContainerInternal
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'Address ... Remove this comment to see the full error message
          address={getValue(addressKey)}
          namePrefix={addressKey}
          setFetchingAddress={setFetchingAddress}
          updateAddress={(update) => {
            updateValueWith(addressKey, (a) => ({ ...a, ...update }));
          }}
          clearErrors={clearErrors}
          error={errors[addressKey]}
          errors={errors}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    </FormContextConsumer>
  );
}
